import { autoinject, transient } from 'aurelia-dependency-injection';
import { NotifyPropertyChangedBase } from '../../../../../utilities/reflection';
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";

@autoinject
@transient()
export class CloneWorkflowDialog extends NotifyPropertyChangedBase {

    private _cloneFunction: (name: string) => Promise<void>;
    public workflowName: string;

    constructor(private dialogClient: DialogClientService) {
        super();
    }

    cancel() {
        this.dialogClient.hide();
    }

    clone() {
        return new Promise<void>((resolve, reject) => {
            this._cloneFunction(this.workflowName)
                .then(() => {
                    resolve();
                    this.dialogClient.hide();
                }).catch(() => {
                    reject();
                });
        });
    }

    activate(model: any) {
        this._cloneFunction = model.cloneFunction;
    }
}
